import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getPromocode } from '../../../store/actions/user/User';
import Loader from 'react-loader-spinner';
import store from '../../../store/reducers/rootReducer';
import Typography from '@material-ui/core/Typography';
class Cart extends Component {
  state = {
    promocode: 'Promo code not valid',
    color: 'red',
    flag: false,
    msg: '',
    disabled: false,
    show: false
  };
  componentWillMount() {
    this.props.getPromocode();
    store.dispatch({
      type: 'GET_CART',
      payload: { data: JSON.parse(localStorage.getItem('cart')) }
    });
    // setTimeout(() => this.setState({isLoading:false}),2000);
  }
  handlePromocode = (e) => {
    this.setState({ ...this.state, promocode: e.target.value });
  };
  handleSubmit = (event) => {
    event.preventDefault();
    var validPromo = this.props.promocode.promocode.filter(
      (pc) => pc.status === 'enabled' && pc.name === this.state.promocode
    )[0];
    validPromo = validPromo
      ? validPromo
      : { type: 'the promo code you entered is invalid ' };
    if (validPromo.name) {
      this.setState({
        color: 'green',
        msg: 'Promo code applied',
        flag: false
      });
    } else {
      this.setState({
        color: 'red',
        msg: 'Promo Code is not valid',
        falg: true
      });
    }
    this.setState({ promocode: validPromo, flag: true });
  };
  removeFromCart = (product) => {
    var getItems = JSON.parse(localStorage.getItem('cart'));
    var setItems = getItems.filter((item) => item.pid !== product.pid);
    localStorage.setItem('cart', JSON.stringify(setItems));
    store.dispatch({ type: 'GET_CART', payload: { data: setItems } });
  };

  handleQuantity = (product, change) => {
    var updateItemIndex;
    var getItems = JSON.parse(localStorage.getItem('cart'));
    var setItems = getItems.forEach((item, index) => {
      if (item.pid !== product.pid) {
        return item;
      } else {
        updateItemIndex = index;
      }
    });
    var newQuantity;
    if (product.quantity > 1 && change === -1) {
      newQuantity = { ...product, quantity: product.quantity - 1 };
      setItems.splice(updateItemIndex, 0, newQuantity);
      store.dispatch({ type: 'GET_CART', payload: { data: setItems } });
    } else if (change === 1) {
      newQuantity = { ...product, quantity: product.quantity + 1 };
      setItems.splice(updateItemIndex, 0, newQuantity);
      store.dispatch({ type: 'GET_CART', payload: { data: setItems } });
    }
    localStorage.setItem('cart', JSON.stringify(setItems));
    store.dispatch({ type: 'GET_CART', payload: { data: setItems } });
  };

  render() {
    // if (this.state.isLoading) return <Loader/>
    const cart = localStorage.getItem('cart')
      ? JSON.parse(localStorage.getItem('cart'))
      : [];
    var color = this.state.color;
    var msg = this.state.msg;
    var flag = this.state.flag;
    const auth = this.props.auth;

    let c = 0;
    const total = cart
      ? cart.map((item) => (c += parseInt(item.price) * item.quantity))
      : 0;
    const t = total[total.length - 1];
    const pc = this.state.promocode;
    var gt = 0;
    var p;
    if (pc.type === 'cash') {
      p = pc.amount;
      gt = p > t ? 0 : t - p;
    } else if (pc.type === 'percentage') {
      p = (pc.amount * t) / 100;
      gt = t - p;
    } else if (pc.type !== undefined) {
      p = 0;
      gt = t;
    } else {
      p = 0;
      gt = t;
    }
    localStorage.setItem('totalCost', gt);
    localStorage.setItem('promoCost', p);
    localStorage.setItem('cost', t);
    let cart1 = 'Your Cart is Empty';
    if (cart) {
      cart1 = (
        <tbody>
          {cart.map((item) => (
            <tr>
              <td className="product-col">
                <img src="img/cart/1.jpeg" alt="" />
                <div className="pc-title">
                  <h5>{item.name}</h5>
                  <p>{item.description}</p>
                </div>
              </td>
              <td className="size-col">
                <div className="quantity">
                  <button
                    className="btnAdd site-btn"
                    disabled={this.state.disabled}
                    onClick={() => this.handleQuantity(item, -1)}
                    style={{
                      'min-width': '5px',
                      padding: '5px 10px 5px',
                      'border-radius': '0'
                    }}
                  >
                    -
                  </button>
                  <div
                    className="pro-qty"
                    style={{
                      width: '30px',
                      'border-radius': '0',
                      height: '29px',
                      'text-align': 'center',
                      padding: '0'
                    }}
                  >
                    <input type="text" value={item.quantity} />
                  </div>
                  <button
                    className="btnAdd site-btn"
                    disabled={this.state.disabled}
                    onClick={() => this.handleQuantity(item, 1)}
                    style={{
                      'min-width': '5px',
                      padding: '5px 10px 5px',
                      'border-radius': '0'
                    }}
                  >
                    +
                  </button>
                </div>
              </td>
              <td className="total-col">
                <h4>${parseInt(item.price) * item.quantity}</h4>
              </td>
              <td className="size-col">
                <button
                  disabled={this.state.disabled}
                  className="site-btn"
                  style={{ 'min-width': '60px', padding: '10px 15px 10px' }}
                  onClick={() => this.removeFromCart(item)}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      );
    } else {
      cart1 = (
        <tbody>
          <div style={{ marginLeft: '50%' }}>
            <Loader
              type="ThreeDots"
              color="#d50000"
              height={100}
              width={100}
              timeout={1000}
              style={{ 'margin-left': '100px' }}
            />
          </div>
        </tbody>
      );
    }
    return (
      <div>
        <div className="page-top-info">
          <div className="container">
            <h4>Your cart</h4>
            <div className="site-pagination">
              <Link to="/">Home</Link>&nbsp;&nbsp;&nbsp;
              <Link to="/cart">Your cart</Link>
            </div>
          </div>
        </div>
        {cart.length > 0 ? (
          <section className="cart-section spad">
            <div className="container">
              <div className="row">
                <div className="col-lg-8">
                  <div className="cart-table">
                    <h3>Your Cart</h3>
                    <div
                      className="cart-table-warp"
                      style={{ overflow: 'scroll' }}
                    >
                      <table>
                        <thead>
                          <tr>
                            <th className="product-th">Product</th>
                            <th className="quy-th">Quantity</th>
                            <th className="total-th">Price</th>
                            <th className="size-th">Action</th>
                          </tr>
                        </thead>
                        {cart1}
                      </table>
                    </div>
                    <div className="total-cost">
                      <h6>
                        SubTotal <span>$ {!t ? 0 : t}</span>
                      </h6>
                      <h6>
                        Promo Code<span>-$ {p}</span>
                      </h6>
                      <h6>
                        Total <span>$ {!gt ? 0 : gt}</span>
                      </h6>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 card-right">
                  <form
                    className="promo-code-form"
                    onSubmit={this.handleSubmit}
                  >
                    <input
                      type="text"
                      placeholder="Enter promo code"
                      id="promocode"
                      name="promocode"
                      onChange={this.handlePromocode}
                    />
                    <button className="btnAdd">Apply</button>
                  </form>
                  <span>
                    {flag ? (
                      <h6 style={{ color: `${color}` }}> {msg} </h6>
                    ) : null}
                  </span>
                  {auth ? (
                    <Link to="/checkout" className="site-btn">
                      Proceed to checkout
                    </Link>
                  ) : (
                    <Link to="/signin" className="site-btn">
                      Proceed to checkout
                    </Link>
                  )}
                  <Link to="/" className="site-btn sb-dark text-white">
                    Continue shopping
                  </Link>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <div style={{ margin: '20%' }}>
            <Typography variant="h4" align="center">
              Nothing In Your Cart
            </Typography>
          </div>
        )}
      </div>
    );
  }
}
const mapStateWithProps = (state) => ({
  cart: state.user.cart,
  promocode: state.user.promocode,
  auth: state.user.auth
});

const mapDispatchToProps = (dispatch) => ({
  getPromocode: () => dispatch(getPromocode())
});

export default connect(mapStateWithProps, mapDispatchToProps)(Cart);
